<!--
 * @Author: 仙道
 * @Date: 2022-08-27 18:05:44
 * @LastEditTime: 2022-08-27 18:15:00
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/components/jeecgbiz/JSelectDeviceByProcess.vue
-->
<template>
  <div>
    <a-input-search @search="onSearchDepUser" placeholder="请先选择设备" readonly unselectable="on" v-model="textVals">
      <a-button :disabled="disabled" slot="enterButton">选择设备</a-button>
    </a-input-search>
    <j-select-device-by-process-modal
      :modal-width="modalWidth"
      :multi="multi"
      :store="storeField"
      :text="textField"
      :user-ids="value"
      @initComp="initComp"
      @ok="selectOK"
      ref="selectModal"
    />
  </div>
</template>

<script>
  import JSelectDeviceByProcessModal from './modal/JSelectDeviceByProcessModal'
  import { underLinetoHump } from '@/components/_util/StringUtil'

  export default {
    name: 'JSelectDeviceByProcess',
    components: { JSelectDeviceByProcessModal },
    props: {
      modalWidth: {
        type: Number,
        default: 1250,
        required: false
      },
      value: {
        type: String,
        required: false
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      multi: {
        type: Boolean,
        default: true,
        required: false
      },
      backUser: {
        type: Boolean,
        default: false,
        required: false
      },
      // 存储字段 [key field]
      store: {
        type: String,
        default: 'username',
        required: false
      },
      // 显示字段 [label field]
      text: {
        type: String,
        default: 'realname',
        required: false
      }
    },
    data () {
      return {
        storeVals: '', //[key values]
        textVals: '' //[label values]
      }
    },
    computed: {
      storeField () {
        let field = this.customReturnField
        if (!field) {
          field = this.store;
        }
        return underLinetoHump(field)
      },
      textField () {
        return underLinetoHump(this.text)
      }
    },
    mounted () {
      this.storeVals = this.value
    },
    watch: {
      value (val) {
        this.storeVals = val
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    methods: {
      initComp (textVals) {
        this.textVals = textVals
      },
      //返回选中的用户信息
      backDeparInfo () {
        if (this.backUser === true) {
          if (this.storeVals && this.storeVals.length > 0) {
            let arr1 = this.storeVals.split(',')
            let arr2 = this.textVals.split(',')
            let info = []
            for (let i = 0; i < arr1.length; i++) {
              info.push({
                value: arr1[i],
                text: arr2[i]
              })
            }
            this.$emit('back', info)
          }
        }
      },
      onSearchDepUser () {
        this.$refs.selectModal.showModal()
      },
      selectOK (rows) {
        console.log("当前选中用户", rows)
        if (!rows) {
          this.storeVals = ''
          this.textVals = ''
        } else {
          let temp1 = []
          let temp2 = []
          for (let item of rows) {
            temp1.push(item[this.storeField])
            temp2.push(item[this.textField])
          }
          this.storeVals = temp1.join(',')
          this.textVals = temp2.join(',')
        }
        this.$emit("change", this.storeVals)
      }
    }
  }
</script>

<style scoped>


</style>